import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { IonicModule } from '@ionic/angular';

@NgModule({
    declarations: [AppComponent],
    imports: [
        AppRoutingModule,
        CoreModule,
        SharedModule,
        IonicModule.forRoot({}),
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
